import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<img \n  src={{this.path}} \n  ...attributes\n/>\n",{ moduleName: "garaje/pods/components/homepage/dashboard-image/template.hbs" })